import { Injectable } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';
import { AbstractApiService } from '../../shared/services';
import { UserRoleService } from '../../shared/services/user-role.service';

@Injectable({
  providedIn: 'root'
})
export class RemoteAccessReasonsService {
  constructor(
    private apiService: AbstractApiService,
    private rolesService: UserRoleService
  ) {}

  readRemoteAccessReason(iri: string): Observable<any> {
    return this.rolesService.userHasRoleFilter<any>(
      'ROLE_MWS_TICKET_VIEW',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(iri, true)
    );
  }

  readRemoteAccessReasons(): Observable<any> {
    return this.rolesService.userHasRoleFilter<any>(
      'ROLE_MWS_TICKET_LIST',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.getObject('/remote_access_reasons')
    );
  }
}
